import React, { Component } from 'react';
import { Drawer } from '@mui/material/';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SidebarTitle from './SidebarTitle'
import clsx from 'clsx'
import './SideBar.scss';

class sideMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            lastOpen: !!props.open,
        };
    }

    /*
     * Accessibility workaround for MUI Drawer (Modal) close behavior.
     *
     * When the parent flips `open` from true to false, MUI's Modal commits
     * `aria-hidden="true"` on the Drawer's root element while the close
     * transition plays out. The inner `<div id="sidebar" tabIndex={-1}>` is
     * the element MUI's FocusTrap focuses when the drawer opens, so at the
     * moment aria-hidden is applied focus is still inside the now-hidden
     * subtree. Chrome (and accessibility tools) then emit:
     *   "Blocked aria-hidden on an element because its descendant retained focus."
     *
     * `getDerivedStateFromProps` runs during the render phase, BEFORE React
     * commits the new DOM (and therefore before MUI sets aria-hidden). By
     * blurring the focused descendant here, focus is moved to <body> before
     * the hidden subtree exists, so no warning is emitted.
     *
     * Strictly speaking this is a side-effect inside a method that React
     * documents as pure; `blur()` is idempotent so a double-invocation under
     * concurrent rendering is harmless. The alternative (buffered internal
     * `open` state) works too but adds an extra render cycle.
     *
     * This entire block can be removed once MUI switches Modal/Drawer close
     * behavior from `aria-hidden` to the `inert` attribute (planned post-v6;
     * not the default in the @mui/material v6.x line currently in use).
     */
    static getDerivedStateFromProps(props, state) {
        if (state.lastOpen && !props.open && typeof document !== 'undefined') {
            const sidebar = document.getElementById('sidebar');
            const active = document.activeElement;
            if (sidebar && active && sidebar.contains(active) && typeof active.blur === 'function') {
                active.blur();
            }
        }
        return { lastOpen: !!props.open };
    }

    handleDrawerOpen = () => {
        this.setState({ open: true });
    }

    handleDrawerClose = () => {
        this.setState({ open: false });
    }
    render() {
        const { className, isCloseOnOutsideClick = true } = this.props;
        return (
            <Drawer
                anchor="right"
                open={this.props.open}
                onClose={
                    () => {
                        if (isCloseOnOutsideClick && this.props.handleDrawerClose) {
                            this.props.handleDrawerClose();
                        }
                    }
                }
                className="sidebar-drawer"
            >
                <div
                    id='sidebar'
                    tabIndex={-1}
                    className={clsx(className, 'sidebar-panel')}
                >
                    {this.props.title ?
                        <div className="sidebar-header-form" >
                            <SidebarTitle
                                title={this.props.title}
                                icon={this.props.icon}
                            />
                            <div className="sidebar-close-icon" onClick={this.props.handleDrawerClose}>
                                <FontAwesomeIcon color="#BABABA" icon={['fal', 'times']} size="2x" />
                            </div>
                        </div>
                        : ''}
                    <div className="sidebar-content-wrapper">
                        {this.props.children}
                    </div>
                </div>
            </Drawer>
        )
    }
}
export default sideMenu;
